import React from "react"
import styles from './LoadAnimation.module.css'

export default () => <div className={styles["dot-falling"]}></div>